/**
 * Generate a unique request ID (UUID v4)
 * Uses crypto.randomUUID when available, falls back to a custom implementation
 * @returns {string} A UUID v4 string
 */
export function generateRequestId() {
  // Modern browsers have crypto.randomUUID
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback implementation for older browsers
  return ([1e7]+-1e3+-4e3+-8e3+-1e11)
    .replace(/[018]/g, c => 
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

/**
 * Get the GA4 client ID if available
 * @param {string} measurementId - GA4 measurement ID (e.g., 'G-XXXXXXX')
 * @returns {Promise<string|null>} The client ID or null if not available
 */
export async function getGa4ClientId(measurementId) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return null;
  }

  return new Promise((resolve) => {
    try {
      window.gtag('get', measurementId, 'client_id', (clientId) => {
        resolve(clientId || null);
      });
      // Timeout after 100ms if GA doesn't respond
      setTimeout(() => resolve(null), 100);
    } catch (e) {
      resolve(null);
    }
  });
}



